import React from "react";
import headerfoto from "../images/vito-2024.jpg";

const AboutHeader: React.FC = () => {
  return (
    <div className="relative w-full h-60 md:h-72 lg:h-80 flex items-center justify-center text-center">
      {/* Background Image */}
      <img
        src={headerfoto}
        alt="hakkımızda"
        className="absolute inset-0 w-full h-full object-cover brightness-75"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/50 via-white/50 to-white/50"></div>

      {/* Text Content */}
      <div className="relative z-10">
        <h1 className="text-3xl md:text-4xl font-bold text-[#092049]">Hakkımızda</h1>
        <p className="text-lg md:text-xl text-black ">Kocabay Tur</p>
      </div>
    </div>
  );
};

export default AboutHeader;
